import { useState } from "react";
import { Button, ButtonRow, ContextMenu, ContextMenuItem, Heading, Treegrid } from "cai-fusion";
import { useModels } from "../../contexts/ModelsContext";
import env from "../../../../configs/envConfig";

import { ReactComponent as IconTrash } from "../../../../images/icon-trash.svg";
import { ReactComponent as IconRename } from "../../../../images/icon-rename.svg";
import { ReactComponent as IconMagGlass } from "../../../../images/icon-mag-glass.svg";

import ModelConfigurationDrawer from "./overlay/modelConfigurationDrawer";

const ModelConfiguration = () => {
    const [hideEditDrawer, setHideEditDrawer] = useState(true);

    const { models, resetCurrModel, initializeModifyModel } = useModels();

    const handleOpenDrawer = async (engine = null) => {
        await initializeModifyModel(engine);
        setHideEditDrawer(false);
    }

    return (
        <>
            <div className="row l-mt-sm">
                <div className="col-12">
                    <div className="l-row l-row--justify-between l-row--align-center">
                        <div className="col-md-9">
                            <Heading size={3}>Models</Heading>
                            <p className="a-muted-text">Manage the models that are available to the {env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"} assistant.</p>
                        </div>
                        <div className="col-md-3">
                            <ButtonRow>
                                <Button
                                    children="Add Model"
                                    onClick={() => handleOpenDrawer()}
                                />
                            </ButtonRow>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="o-block">
                        <Treegrid
                            isCompact
                            className="l-mr-sm"
                            columnSizes={["xxx-wide", "small"]}
                        >
                            {models.map((model, index) => {
                                return (
                                    <ModelListItem 
                                        key={index}
                                        model={model} 
                                        onEdit={() => handleOpenDrawer(model.engine)}
                                    />
                                )
                            })}
                        </Treegrid>
                    </div>
                </div>
            </div>
            <ModelConfigurationDrawer
                isHidden={hideEditDrawer}
                onClose={() => {
                    setHideEditDrawer(true);
                    resetCurrModel();
                }}
            />
        </>
    );
}

const ModelListItem = ({model, onEdit}) => {
    const [hideContextMenu, setHideContextMenu] = useState(true);
    const { deleteModel } = useModels(); 

    return (
        <tr className="o-treegrid__row o-treegrid__row--shown">
            <td className="o-treegrid__cell">
                <p className="a-subtle-text l-mb-none"><strong>{model.displayName}</strong></p>
            </td>
            <td className="o-treegrid__cell">
                <div className="m-button-row">
                    <ContextMenu
                        isHidden={hideContextMenu}
                        onClick={() => setHideContextMenu(!hideContextMenu)}
                        onBlur={() => setHideContextMenu(true)}
                    >
                        <ContextMenuItem 
                            Icon={IconRename}
                            name="Rename Model"
                        />
                        <ContextMenuItem
                            Icon={IconTrash}
                            danger
                            name="Delete Model"
                            onClick={() => {
                                deleteModel(model.engine);
                                setHideContextMenu(true);
                            }}
                        />
                    </ContextMenu>
                    <button
                        className="a-icon-link"
                        onClick={onEdit}
                    >
                        <div className="a-icon-link__inner">
                            <div className="a-icon-link__icon-wrapper">
                                <IconMagGlass className="a-icon-link__icon" />
                            </div>
                        </div>
                    </button>
                </div>
            </td>
        </tr>
    );
}

export default ModelConfiguration;